<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h2>{{ $t("tripPlan.editWaypoint") }}</h2>

    <b-form-group :label="$t('workflow.waypoint.waypointDocumentNumberLabel')" label-for="cnpj-input" calss="mb-4">
      <b-form-input id="cnpj-form" type="text" required v-model="model.companyDucumentNumber"
        :placeholder="$t('workflow.waypoint.waypointDocumentNumberLabel')"></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('workflow.waypoint.waypointName')" label-for="input-waypoint-name" class="mb-4">
      <b-form-input id="input-form-name" type="text" v-model="model.name" required
        :placeholder="$t('workflow.waypoint.waypointName')">
      </b-form-input>
    </b-form-group>
    <b-form-group :label="$t('workflow.waypoint.waypointFullAddress')" label-for="input-waypoint-fullAddress"
      class="mb-4">
      <b-form-input id="input-form-name" type="text" v-model="model.fullAddress" required
        :placeholder="$t('workflow.waypoint.waypointFullAddress')">
      </b-form-input>
    </b-form-group>
    <!-- <div>model: {{ model }}</div> -->
    <!-- <div>markerCrud: {{ markerCrud }}</div> -->
    <div v-if="mapEngine === '0'">
      <leaflet-marker-crud :model.sync="markerCrud" :id="'map2'" />
    </div>
    <div v-if="mapEngine === '1'">
      <google-map-marker-crud :model.sync="markerCrud" :id="'map2'" />
    </div>

    <b-button @click="save()" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
    <!-- {{ model }} -->
    <!-- {{ modelstate }} -->
  </b-container>
</template>
<script>
export default {
  name: "WaypointEdit",
  props: {
    id: String
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    LeafletMarkerCrud: () =>
      import("@/components_rms/base/leaflet/crud/LeafletMarkerCrud.vue"),
    GoogleMapMarkerCrud: () =>
      import("@/components_rms/base/googlemaps/crud/GoogleMapMarkerCrud.vue")
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      mapEngine: localStorage.getItem("mapEngine"),
      alert: {
        error: "",
        success: "Ponto de parada alterado com sucesso"
      },
      model: {},
      modelstate: {},
      markerCrud: {
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0
      },
      submitted: false
    };
  },

  methods: {
    loadData() {
      this.$apiWorkflow
        .get("/waypoint/getById/" + this.id)
        .then(response => {
          this.model = response.data;
          this.markerCrud = {
            latitude: response.data.latitude,
            longitude: response.data.longitude,
            fullAddress: response.data.fullAddress,
            companyDucumentNumber: response.data.companyDucumentNumber
          };
        })
        .catch(error => {
          console.log(error);
          this.submitted = false;
          this.modelstate = error.response.data.errors;
          this.$refs.danger.show();
        });
    },
    save() {
      this.submitted = true;
      this.model.latitude = this.markerCrud.latitude;
      this.model.longitude = this.markerCrud.longitude;
      this.model.fullAddress = this.markerCrud.fullAddress;
      this.model.companyDucumentNumber = this.markerCrud.companyDucumentNumber;

      this.$apiWorkflow
        .post("/waypoint/save/", this.model)
        .then(response => {
          this.$refs.alert.show();
          this.submitted = false;
        })
        .catch(error => {
          console.log(error);
          this.submitted = false;
          this.alert.error =
            error.response.status + " - " + error.response.data.errorMessage;
          this.$refs.danger.show();
        });
    }
  }
};
</script>
